import { isEmpty } from 'lodash';

import React, { Fragment } from 'react';

const SimpleList = ({ itemsList }) => {
  return (
    <Fragment>
      {!isEmpty(itemsList) && itemsList.map((item, i) => <p key={i}>{item}</p>)}
    </Fragment>
  );
};

export default SimpleList;
